import LazyImage from './js/lazy-image';

export {
    LazyImage,
};
